var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect2, _ellipse, _ellipse2, _circle, _circle2, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _path17, _path18, _path19, _circle3, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 400,
    viewBox: "0 0 300 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_44)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 400,
    fill: "#FFD15C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0794 218.261L37.0001 215.181",
    stroke: "#FF4D61",
    strokeWidth: 5.12,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0794 231.326L37.0001 234.406",
    stroke: "#FF4D61",
    strokeWidth: 5.12,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1577 218.251L56.2267 215.181",
    stroke: "#FF4D61",
    strokeWidth: 5.12,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1449 231.316L56.2395 234.411",
    stroke: "#FF4D61",
    strokeWidth: 5.12,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.128 245.907C112.707 250.605 95.4906 260.829 61.9982 264.145C20.1326 268.29 4.79573 278.239 -4.73801 289.016C-14.2717 299.793 -17.5878 402.936 -17.5878 414.957H149.997V410.453H317.587C317.587 398.432 314.271 299.793 304.738 289.016C295.204 278.239 279.867 268.29 238.001 264.145C204.509 260.829 187.293 250.605 182.872 245.907H149.997H144.522H117.128Z",
    fill: "#6C6CFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.529 236.889H199.464V269.803C199.464 297.123 177.317 319.27 149.996 319.27C122.676 319.27 100.529 297.123 100.529 269.803V236.889Z",
    fill: "#F37E5A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3679 146.173C66.0001 96.5854 99.9367 82.0419 117.201 80.9685C140.567 58.7666 229.075 69.6986 229.075 146.173C229.075 222.647 172.22 228.838 149.479 228.838C126.737 228.838 71.3275 208.157 68.3679 146.173Z",
    fill: "#32304F",
    stroke: "#32304F",
    strokeWidth: 5.11733,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M219.282 174.83C212.4 174.83 209.698 179.819 209.698 183.116V210.949C222.107 210.949 229.112 200.326 229.112 189.915C229.112 184.69 226.835 174.83 219.282 174.83Z",
    fill: "#F37E5A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7103 174.83C87.5927 174.83 90.2943 179.819 90.2943 183.116V210.949C77.8858 210.949 70.8808 200.326 70.8808 189.915C70.8808 184.69 73.1575 174.83 80.7103 174.83Z",
    fill: "#F37E5A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90.2943,
    y: 124.805,
    width: 119.404,
    height: 144.991,
    rx: 59.7022,
    fill: "#F5A46E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 189.698,
    cy: 200.541,
    rx: 9.76554,
    ry: 4.21146,
    fill: "#F37E5A"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.294,
    cy: 200.541,
    rx: 9.76554,
    ry: 4.21146,
    fill: "#F37E5A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119.296,
    cy: 183.359,
    r: 5.11733,
    fill: "#32304F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.704,
    cy: 183.359,
    r: 5.11733,
    fill: "#32304F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M147.877 183.573C145.78 188.53 140.251 196.156 137.01 202.638C133.599 209.459 137.009 217.509 151.69 217.509",
    stroke: "#DA6541",
    strokeWidth: 5.11733,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136.908 226.411C139.745 228.836 144.723 230.445 150.39 230.445C156.057 230.445 161.035 228.836 163.871 226.411",
    stroke: "#DA6541",
    strokeWidth: 5.11733,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.146 132.618C133.666 135.33 137.875 141.129 138.981 150.781C139.853 158.38 144.499 166.252 151.69 169.65",
    stroke: "#32304F",
    strokeWidth: 5.11733,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M149.996 271.502V271.502C182.969 271.502 209.699 244.772 209.699 211.799V186.213C209.699 153.24 182.969 126.511 149.996 126.511V126.511C117.024 126.511 90.2943 153.24 90.2943 186.213L90.2943 204.1",
    stroke: "#DA6541",
    strokeWidth: 5.11733,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M141.622 145.199C137.888 136.271 128.297 130.657 125.389 130.184C169.622 110.3 209.741 142.799 209.741 176.555C201.218 176.555 185.748 175.597 175.543 172.497C156.399 166.681 146.288 156.358 141.622 145.199Z",
    fill: "#32304F",
    stroke: "#32304F",
    strokeWidth: 5.11733,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_44",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 236,
    width: 100,
    height: 84
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100.529 236.889H199.464V269.803C199.464 297.123 177.317 319.27 149.996 319.27C122.676 319.27 100.529 297.123 100.529 269.803V236.889Z",
    fill: "#F37E5A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.699 210.556V211.8C209.699 244.772 182.969 271.502 149.996 271.502V271.502",
    stroke: "#DA6541",
    strokeWidth: 5.11733,
    strokeLinecap: "round"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M117.895 154.719C118.478 141.693 124.295 134.71 127.13 132.846C92.7175 125.847 88.9748 162.982 91.405 182.424C109.632 182.424 117.166 171.002 117.895 154.719Z",
    fill: "#32304F",
    stroke: "#32304F",
    strokeWidth: 5.11733,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.031 160.287C173.119 157.832 162.297 151.631 153.714 140.318C149.872 135.253 143.037 125.462 131.431 124.07",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 5.11733,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M115.298 79.8733C106.652 76.3049 89.4416 75.6737 74.9487 91.8135C56.8325 111.988 67.5375 138.751 71.2431 142.044",
    stroke: "#32304F",
    strokeWidth: 5.11733,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M257.87 232.322L261.2 234.09C261.948 234.487 262.845 234.487 263.594 234.09L266.924 232.322C268.129 231.682 269.435 232.988 268.795 234.193L267.027 237.523C266.629 238.271 266.629 239.168 267.027 239.917L268.795 243.247C269.435 244.452 268.129 245.758 266.924 245.118L263.594 243.349C262.845 242.952 261.948 242.952 261.2 243.349L257.87 245.118C256.665 245.758 255.359 244.452 255.999 243.247L257.767 239.917C258.165 239.168 258.165 238.271 257.767 237.523L255.999 234.193C255.359 232.988 256.665 231.682 257.87 232.322Z",
    fill: "#FF4D61"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.3369,
    cy: 151.134,
    r: 6.21675,
    fill: "#59B3A7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M243.56 7.38138C243.56 12.8748 239.107 17.3282 233.613 17.3282C228.12 17.3282 223.666 12.8748 223.666 7.38138C223.666 1.88791 228.12 -2.56543 233.613 -2.56543C239.107 -2.56543 243.56 1.88791 243.56 7.38138Z",
    fill: "#6C6CFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M179.014 47.7394L175.806 47.7392",
    stroke: "#449A93",
    strokeWidth: 5.12,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M185.818 54.5439L185.819 57.7516",
    stroke: "#449A93",
    strokeWidth: 5.12,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M185.82 40.9229L185.82 37.726",
    stroke: "#449A93",
    strokeWidth: 5.12,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M192.617 47.7343L195.841 47.7345",
    stroke: "#449A93",
    strokeWidth: 5.12,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 400,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKent);
export default __webpack_public_path__ + "static/media/Kent.8e025af2eaf0a0ffb84fcd47301ea126.svg";
export { ForwardRef as ReactComponent };